<template>
  <ModalStep
    id="add-deliverable-modal-content"
    data-test-id="title-add-deliverable"
    :header="{
      title: t('session.reviewModal.addDeliverableModal.title'),
    }"
  >
    <template #bodyContent>
      <AddDeliverable @update:isUploadingRef="isUploadingRef = $event" @update:isDisabledRef="isDisabledRef = $event" />
    </template>

    <template #footer>
      <div class="c-btns-container">
        <CustomButton
          :isDisabled="false"
          usage="button"
          type="submit"
          color="white"
          data-test-id="addDeliverable-sendLater"
          :text="t('session.reviewModal.addDeliverableModal.sendLater')"
          @emit:click="onClose"
        />
        <CustomButton
          :isDisabled="!isDisabledRef"
          :isLoading="isUploadingRef"
          usage="button"
          type="submit"
          color="primary"
          data-test-id="addDeliverable-next"
          :text="t('session.reviewModal.addDeliverableModal.next')"
          @emit:click="onNext"
          icon-position="right"
        >
          <template #icon>
            <ArrowIcon color="white" />
          </template>
        </CustomButton>
      </div>
    </template>
  </ModalStep>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import { selectGetSelectedGroupId } from '@/features/groups/stores/groups/groups.selectors'
import groupsStore from '@/features/groups/stores/groups/groups.store'
import AddDeliverable from '@/features/sessions/components/add-deliverable/add-deliverable.vue'
import { useSessionInReview } from '@/features/sessions/hooks/use-in-review-session.hook'
import CustomButton from '@/features/ui/components/button/custom-button.vue'
import ArrowIcon from '@/features/ui/components/icons/arrow-icon.vue'
import ModalStep from '@/features/ui/components/modal/modal-step/modal-step.vue'
import { selectGetReviewSessionModal } from '@/features/ui/store/modal/modal.selectors'
import modalsStore from '@/features/ui/store/modal/modal.store'
import { useI18n } from '@/lib/i18n'
import { DO_NOT_ASK_REVIEW_AGAIN } from '@/utils/config/constants'
import { invalidateDeliverables, invalidateSession, invalidateSessions } from '@/utils/lib/vue-query'

const selectedGroupIdRef = selectGetSelectedGroupId(groupsStore)
const reviewSessionModalRef = selectGetReviewSessionModal(modalsStore)
const { t } = useI18n()

// :isDisabled="!isNoDeliverableRef && isFilesUploadingRef.find((i) => i.isUploading)?.isUploading"
const isUploadingRef = ref(false)

// :isDisabled="deliverablesRef.length === 0 || filesRef.length === 0"
const isDisabledRef = ref(false)

const { onClickNextStep } = useSessionInReview()

async function onNext() {
  await invalidateSessions({ groupId: selectedGroupIdRef.value! })
  await invalidateSession(reviewSessionModalRef.value.attachedData.sessionId!)
  await invalidateDeliverables({ sessionId: reviewSessionModalRef.value.attachedData.sessionId! })
  onClickNextStep()
}

function onClose() {
  modalsStore.toggleModal('review-session', false)
  sessionStorage.setItem(DO_NOT_ASK_REVIEW_AGAIN, 'true')
}
</script>

<style lang="scss">
@import './add-deliverable-modal-content.scss';
</style>
